import { useState } from "react";
import { useGet } from "hooks/query";
import { endpoints } from "services/endpoints";

const useWarehouse = (parent_id) => {
  const [warehouseOptions, setWarehouseOptions] = useState([]);

  useGet({
    link: endpoints.warehouse.list,
    params: { org_id: parent_id },
    enabled: !!parent_id,
    onSuccess: (res) => {
      const optionTransformation = res?.map((el) => ({
        label: el.name,
        value: el.id,
      }));
      setWarehouseOptions(optionTransformation);
    },
  });

  return { warehouseOptions };
};

export default useWarehouse;
